var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDieselFrontwheels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 82,
    viewBox: "0 0 323 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 281.214,
    cy: 40.8006,
    r: 36,
    fill: "black",
    stroke: "#F9CE4E",
    strokeWidth: 9.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50.4207,
    cy: 40.8006,
    r: 36,
    fill: "black",
    stroke: "#F9CE4E",
    strokeWidth: 9.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 272.186,
    cy: 40.8006,
    r: 36,
    fill: "black",
    stroke: "#F9CE4E",
    strokeWidth: 9.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 41.4012,
    cy: 40.8006,
    r: 36,
    fill: "black",
    stroke: "#F9CE4E",
    strokeWidth: 9.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDieselFrontwheels);
export default __webpack_public_path__ + "static/media/diesel-frontwheels.69337e34cbf2b05084f57573ea32242b.svg";
export { ForwardRef as ReactComponent };